/**
 * Recursively extracts plain text from an mdast node, including nested link/emphasis/strong
 * nodes (which have .children, not .value) and inlineCode nodes (which have .value).
 *
 * Needed because RkLinkifier's remark plugin runs BEFORE tree/index formatters and splices
 * a raw RK hash inside a paragraph's text into a `link` node — a naive `child.value` read
 * (link nodes have no .value) silently drops the hash. This walks the full node tree instead.
 *
 * @param {object} node - mdast node (paragraph, text, link, inlineCode, etc.)
 * @returns {string}
 */
export function extractText(node) {
    if (node == null) return '';
    if (typeof node.value === 'string') return node.value;
    if (Array.isArray(node.children)) return node.children.map(extractText).join('');
    return '';
}

/**
 * Concatenates all descendant text of a paragraph's children array.
 * @param {object} node - mdast paragraph node
 * @returns {string}
 */
export function extractParagraphText(node) {
    return (node.children || []).map(extractText).join('');
}
